import { ColGroupDef } from "ag-grid-enterprise";
import {
  dueDateCellRenderer,
  materialDueDateHeaderComponent,
  riskCellRenderer
} from "components/cell-renders";
import { InnerIdLinkMaterialRenderer } from "pages/reports-menu/components/cellRenderer";
import { TLinkedMaterial } from "../models";
import {
  getActivityValueGetterData,
  getLinkedSubmittalGetterData,
  valueGetterMaterialDueDate,
  valueGetterMaterialGcRepresentative,
  valueGetterMaterialId,
  valueGetterMaterialName,
  valueGetterMaterialResponsibleContractor,
  valueGetterMaterialRisk,
  valueGetterMaterialSpecSection
} from "../utils/value-getters";

export const materialColDef = [
  {
    headerName: "Linked Materials",
    children: [
      {
        colId: "material_id",
        field: "material_id",
        tooltipField: "material_id",
        headerName: "Material ID",
        headerTooltip: "Material ID",
        cellRenderer: "agGroupCellRenderer",
        cellRendererParams: {
          innerRenderer: InnerIdLinkMaterialRenderer
        },
        valueGetter: valueGetterMaterialId,
        getQuickFilterText: (params) => {
          const { value, data, context } = params;
          let allValues = [value];
          data.linked_submittals.forEach((s) => {
            allValues = allValues.concat(
              getLinkedSubmittalGetterData({ data: s.submittal, context })
            );
          });
          if (data.parentActivity) {
            allValues = allValues.concat(
              getActivityValueGetterData(data.parentActivity)
            );
          }
          return allValues.join(" ");
        }
      },
      {
        colId: "specsection",
        headerName: "Spec Section",
        headerTooltip: "Spec Section",
        valueGetter: valueGetterMaterialSpecSection,
        tooltipValueGetter: ({ value }) => value
      },
      {
        colId: "name",
        field: "name",
        headerName: "Material Name",
        headerTooltip: "Material Name",
        tooltipField: "name",
        valueGetter: valueGetterMaterialName
      },
      {
        colId: "status",
        field: "status",
        headerName: "Material Status",
        headerTooltip: "Material Status",
        tooltipField: "status"
      },
      {
        colId: "gc_representative",
        headerName: "GC Representative",
        headerTooltip: "GC Representative",
        valueGetter: valueGetterMaterialGcRepresentative,
        tooltipValueGetter: ({ value }) => value
      },
      {
        colId: "responsible_contractor_name",
        headerName: "Responsible Contractor",
        headerTooltip: "Responsible Contractor",
        valueGetter: valueGetterMaterialResponsibleContractor,
        tooltipValueGetter: ({ value }) => value
      },
      {
        colId: "due_date",
        headerName: "Due Date",
        headerTooltip: "Due Date",
        headerComponentParams: materialDueDateHeaderComponent,
        valueGetter: valueGetterMaterialDueDate,
        sort: "asc",
        tooltipValueGetter: ({ value }) => value,
        cellRenderer: dueDateCellRenderer
      },
      {
        colId: "risk",
        headerName: "Risk",
        headerTooltip: "Risk",
        valueGetter: valueGetterMaterialRisk,
        cellRenderer: riskCellRenderer,
        tooltipValueGetter: ({ value }) => value
      }
    ]
  }
] as ColGroupDef<TLinkedMaterial>[];
